import {
  faMedium,
  faDiscord,
  faGithub,
} from '@fortawesome/free-brands-svg-icons';
import {
  faGlobe,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

export const ICONS = [
  faMedium,
  faDiscord,
  faGithub,
  faGlobe,
  faEnvelope,
];
